const locale = {
  COMMON: {
    TITLE_LOGIN: 'Iniciar sesión',
    COLH_ACCT_NO: 'Nombre de usuario',
    COLH_EMAIL: 'Correo electrónico',
    COLH_CHECK_EMAIL: 'Confirmar correo electrónico',
    TXT_ACCOUNT_DESC: 'Escriba su nombre de usuario.',
    COLH_CIPHER: 'Contraseña',
    COLH_HELP_DOC: 'Manual del usuario',
    TXT_CIPHER_DESC: 'Escriba la contraseña.',
    BTN_FORGET_CIPHER: 'Olvidé mi contraseña',
    BTN_LOGIN: 'Iniciar sesión',
    BTN_LOGIN_ING: 'Iniciando sesión...',
    BTN_BACK_TO_LOGIN: 'Volver al inicio de sesión',
    BTN_RETURN: 'Atrás',
    BTN_SUBMIT: 'Enviar',
    TITLE_MENUGROUP: 'Grupo de menús',
    TITLE_PURVIEW_POINT: 'Permiso',
    TITLE_AVAILABLE_STRUCTURE: 'Estructura organizativa visible',
    LABEL_OPERATION: 'Operaciones',
    ENABLE: 'Habilitado',
    DISABLE: 'Deshabilitado',
    MSG_SERVER_ERROR: 'Error del sistema. Póngase en contacto con el administrador del sistema.',
    MSG_NO_PERMISSION: 'Lo sentimos. No tiene permiso de acceso. Póngase en contacto con el administrador del sistema.',
    MSG_ASSIGN_SUCCESS: 'Se asignaron los roles seleccionados al usuario.',
    MSG_ASSIGN_STRUCTURE_SUCCESS: 'El usuario se asignó a la estructura organizativa seleccionada.',
    MSG_ASSIGN_USER_GROUP_SUCCESS: 'El usuario se asignó a los grupos de usuarios seleccionados.',
    ERRMSG_NO_PERMISSION: 'No tiene permiso de acceso. Volviendo a la página de inicio.',
    TITLE_NO_PERMISSION: 'Acceso denegado',
    TITLE_ERROR: 'Error',
    BTN_MANAGE: 'Administrar',
    BTN_DELETE: 'Eliminar',
    BTN_REMOVE: 'Quitar',
    BTN_CANCEL: 'Cancelar',
    BTN_CONFIRM: 'OK',
    PRMTMSG_DELETE_SUCCEED: 'Operación correcta',
    LABEL_NAME: 'Nombre',
    BTN_EDIT: 'Editar',
    PRMTMSG_NAME_NOT_REPEAT: 'El nombre ya existe',
    HINT_INPUT_PLACEHOLDER: 'Entrar',
    NO_CONTENT: 'Sin datos',
    INLINE_NEEDED: 'Obligatorio',
    INLINE_NAME_MAX_LENGTH: 'Utilice un máximo de 20 caracteres.',
    FORMMSG_INPUT: 'La descripción es obligatoria.',
    BTN_LOGOUT: 'Cerrar sesión',
    BTN_SWITCH_OU: 'Cambiar empresa',
    TITLE_SWITCH_OU: 'Seleccione una empresa/organización',
    BTN_CHANGE_CIPHER: 'Cambiar contraseña',
    BTN_RENAME: 'Cambiar nombre',
    BTN_I_SEE: 'OK',
    TITLE_DELETE_FAIL: 'Error al eliminar',
    NOT_FOUND1: 'Página no encontrada',
    NOT_FOUND2: 'Lo sentimos, no tiene permiso de acceso.',
    NOT_FOUND_MOBILE: 'No tiene permiso de acceso para la aplicación.',
    NO_AUTH1: 'No tiene permiso de acceso.',
    NO_AUTH2: 'Lo sentimos, no tiene permiso para acceder a la aplicación.',
    NO_AUTH3: 'Póngase en contacto con el administrador del sistema.',
    NOT_AUTH_MOBILE: 'Lo sentimos, no tiene permiso para acceder a la aplicación.',
    TITLE_ADD_FAIL: 'Error al agregar',
    TITLE_MODIFY_FAIL: 'Error al editar',
    TITLE_WELCOME: '¡Bienvenido!',
    COLH_DESCRIPTION: 'Descripción',
    TXT_NO_ROLE: 'No se encontraron roles. Cree un rol o póngase en contacto con el administrador del sistema.',
    NO_DATA: 'No hay resultados coincidentes.',
    PRMTMSG_EXIST_NAME: 'El nombre ya existe',
    MSG_ACCOUNT_REQUIRED: 'El nombre de usuario es obligatorio.',
    MSG_SOURCE_REQUIRED: 'El dominio es obligatorio.',
    MSG_FILE_TYPE_LIMIT: 'El formato de la imagen cargada no se admite.',
    MSG_FILE_SIZE_LIMIT: 'El tamaño de la imagen no puede superar los 2 MB.',
    MSG_TOKEN_EXPIRED: 'La información de inicialización o restablecimiento caducó.',
    HINT_INVALID_PUBLIC_KEY: 'Error de inicio de sesión. Actualice la página y vuelva a intentarlo.',
    TXT_COPY_RIGHT: 'Con tecnología de EnOS',
    TXT_COPY_RIGHT1: ' Con tecnología de EnOS',
    BTN_LAN_SWITCH: 'Cambiar idioma',
    BTN_CHANGE_ORGANIZATION: 'Cambiar empresa/organización',
    TITLE_SETTING: 'Configuración',
    TITLE_CHANGE_CIPHER: 'Cambiar contraseña',
    TXT_CHANGE_CIPHER_NOTE: 'Por la seguridad de su cuenta, cambie la contraseña ahora.',
    TITLE_SELECT_ORGANIZATION: 'Seleccione una empresa/organización',
    TITLE_MENUBAR: 'Barra de menú',
    BTN_EXPAND: 'Ampliar',
    BTN_COLLAPSE: 'Contraer',
    TITLE_SESSION_CONFLICT: 'Se inició sesión en su cuenta desde otra ubicación.',
    TXT_SESSION_CONFLICT: 'La sesión se cerró porque se había iniciado desde la IP: {0}.',
    BTN_CHANGE_THEME: 'Cambiar tema de la barra de navegación',
    TITLE_CHANGE_THEME: 'Cambiar tema de la barra de navegación',
    TXT_CHANGE_THEME_HINT: 'Seleccione un tema para cambiar el color de la barra de navegación.',
    TXT_DARK_THEME: 'Oscuro',
    TXT_BLUE_THEME: 'Verde azulado',
    TITLE_TOKEN_EXPIRED: 'La sesión caducó',
    TXT_EXPIRED_CONTENT: 'Por razones de seguridad, se cerró la sesión debido a que estaba inactiva.',
    TITLE_MULTI_LANGUAGE: 'Varios idiomas',
    BTN_MORE: 'Más',
    BTN_HIDE: 'Contraer',
    BTN_ADMIN: 'Administrador',
    TITLE_ADMIN_INFO: 'Información del administrador',

    TXT_LANGUAGE_EN: 'Inglés (en-US)',
    TXT_LANGUAGE_ZH: 'Chino (zh-CN)',
    TXT_LANGUAGE_JA: 'Japonés (ja-JP)',
    TXT_LANGUAGE_ES: 'Español (es-ES)'
  },

  ROLE: {
    TITLE_ROLE_MANAGE: 'Rol',
    BTN_ADD_NEW_ROLE: 'Nuevo rol',
    HINT_SEARCH_BY_ROLE: 'Buscar por nombre de rol',
    COLH_NAME: 'Nombre del rol',
    COLH_DESCRIPTION: 'Descripción',
    COLH_OPERATE: 'Operaciones',
    COLH_KEY_WORD: 'Palabra clave',
    FORMMSG_ROLE_MANAGE: 'Administrar',
    FORMMSG_ROLE_DELETE: 'Eliminar',
    FORMMSG_ROLE_REMOVE: 'Quitar',
    TITLE_ADDROLE: 'Nuevo rol',
    TITLE_CHOOSE_APP: 'Paso 1. Seleccione una aplicación',
    TITLE_MODIFYROLE: 'Editar rol',
    TITLE_DELETE_ROLE: 'Error al eliminar el rol',
    TITLE_CONFIRM_ROLE: 'Eliminar rol',
    LABEL_ADDROLE_NAME: 'Nombre',
    LABEL_ADDROLE_DESCRIPTION: 'Descripción',
    LABEL_MENUGROUP_NAME: 'Nombre del grupo de menús',
    LABEL_PERMISSION_NAME: 'Nombre del permiso',
    LABEL_PERMISSION_DESC: 'Descripción del permiso',
    LABEL_BELONG_APP: 'Aplicación',
    TITLE_DELETE_FAIL: 'Error al eliminar',
    BTN_CANCEL: 'Cancelar',
    BTN_EDIT: 'Editar',
    BTN_SUBMIT: 'Enviar',
    BTN_CONFIRM: 'OK',
    BTN_CHECK: 'OK',
    BTN_ASSIGNMENT_MENGROUP: 'Asignar grupo de menús',
    BTN_ASSIGNMENT_PURVIEW_POINT: 'Asignar permisos',
    TITLE_ASSIGNMENT_MENGROUP: 'Paso 2. Seleccione un grupo de menús',
    TITLE_ASSIGNMENT_PURVIEW_POINT: 'Paso 2. Seleccionar permisos',
    PRMTMSG_ADDROLE_SUCCESS: 'Se creó el nuevo rol.',
    PRMTMSG_DELROLE_SUCCESS: 'Se eliminó el rol.',
    PRMTMSG_EXIST_ROLE: 'El nombre de rol ya existe.',
    PRMTMSG_MODROLE_SUCCESS: 'Se actualizó el rol.',
    PRMTMSG_REMMGROUP_SUCCESS: 'Se eliminó el grupo de menús.',
    HINT_ADD_ROLE_PLACEHOLDER: 'Escriba el nombre del rol.',
    HINT_ADD_ROLE_DESCRIPTION_PLACEHOLDER: 'Escriba la descripción del rol.',
    PRMTMSG_ASSMGROUP_SUCCESS: 'El grupo de menús se asignó al rol.',
    PRMTMSG_ASSPERMISSION_SUCCESS: 'Los permisos se asignaron al rol.',
    PRMTMSG_REMPERMISSION_SUCCESS: 'Los permisos se quitaron del rol.',
    WINMSG_ROLEDELETE_FAIL: 'El rol tiene asignados usuarios y no se puede eliminar.',
    WINMSG_CHECK: 'Cerrar',
    WINMSG_DELETE_CHECK: 'Los permisos asociados con el rol también se quitarán. ¿Está seguro de que desea eliminar el rol?',
    BTN_FORGET_CIPHER: 'Olvidé mi contraseña',
    TXT_SELECTED_APP: 'Aplicación seleccionada',
    INLINE_NAME_HINT: 'Utilice un máximo de 20 caracteres.',
    MSG_ACCOUNT_REQUIRED: 'El nombre del rol es obligatorio.',
    WINMSG_MENUGRP_DELETE_CHECK: 'El rol perderá los permisos asociados con el grupo de menús. ¿Está seguro de que desea quitar el grupo de menús?',
    HOVER_ROLE_MENUGRP:
      'Un grupo de menús es una colección de menús que aparecen en una aplicación. Cuando asigna un grupo de menús a un rol, los usuarios de dicho rol obtienen acceso a los menús del grupo.',
    HOVER_ROLE_PERMISSION:
      'Un permiso define la operación que los usuarios pueden realizar en las aplicaciones. Cuando asigna un permiso a un rol, los usuarios de dicho rol pueden realizar la operación definida en las aplicaciones.',
    WINMSG_PERMISSION_DELETE_CHECK:
      'El rol perderá acceso a las operaciones asociadas con el permiso. ¿Está seguro de que desea eliminar el permiso?',
    TITLE_DELETE_PERMISSION: 'Quitar permiso',
    WINMSG_APP_NO_PERMISSION: 'No se configuraron permisos para esta aplicación.',
    WINMSG_APP_NO_MENUGROUP: 'No se configuraron menús para esta aplicación.',
    TITLE_DELETE_MENUGROUP: 'Quitar grupo de menús',
    TITLE_ASSGIN_MENU_GROUP: 'Asignar menú',
    TITLE_ROLE_DETAIL: 'Detalles del rol',
    COLH_CREATE_BY: 'Creado por',
    COLH_CREATE_TIME: 'Creado el',
    HOVER_ROLE_STRUCTURE: 'Configure las estructuras organizativas visibles para el rol. Los usuarios de este rol pueden ver la estructura organizativa asignada.',
    BTN_ASSIGNMENT_STRUCTURE: 'Asignar estructura organizativa',
    LABEL_STRUCTURE_NAME: 'Nombre de la estructura organizativa',
    TITLE_DELETE_STRUCTURE: 'Eliminar estructura organizativa visible',
    WINMSG_STRUCTURE_DELETE_CHECK: 'El rol ya no tendrá acceso a esta estructura organizativa una vez que la elimine. ¿Está seguro de que desea eliminar la estructura organizativa?',
    PRMTMSG_REMSTRUCTURE_SUCCESS: 'La estructura organizativa se eliminó',
    WINMSG_APP_NO_STRUCTURE: 'Esta aplicación no tiene ninguna estructura organizativa asignada',
    TITLE_ASSIGNMENT_STRUCTURE: 'Paso 2: Seleccione la estructura organizativa',
    PRMTMSG_ASSSTRUCTURE_SUCCESS: 'La estructura organizativa visible se asignó'
  },
  USERGROUP: {
    TITLE_PAGENAME: 'Grupo de usuarios',
    BTN_ADD_USER_GROUP: 'Nuevo grupo de usuarios',
    TITLE_ADD_USER_GROUP: 'Nuevo grupo de usuarios',
    COLH_NAME: 'Nombre del grupo de usuarios',
    COLH_DESCRIPTION: 'Descripción',
    LABEL_NAME: 'Nombre',
    LABEL_DESCRIPTION: 'Descripción',
    INLINE_NAME_HINT: 'Utilice un máximo de 20 caracteres.',
    BTN_OKTEXT: 'Enviar',
    BTN_OKCONFIRM: 'OK',
    BTN_CANCELTEXT: 'Cancelar',
    PRMTMSG_ADD_SUCCEED: 'Se creó el grupo de usuarios.',
    TITLE_MODIFY_USER_GROUP: 'Editar grupo de usuarios',
    WINMSG_DELETE_HINT: 'Los permisos asociados con el grupo de usuarios también se quitarán. ¿Está seguro de que desea eliminar el grupo de usuarios?',
    PRMTMSG_DELETE_SUCCEED: 'Se eliminó el grupo de usuarios.',
    BTN_OKTEXT_IKNOW: 'Cerrar',
    HINT_SEARCH_USER_GROUP: 'Buscar por nombre de grupo de usuarios',
    TITLE_CONFIRM_DELETE: 'Eliminar grupo de usuarios',
    INLINE_DESCRIPTION_MAX_LENGTH: 'Utilice un máximo de 50 caracteres.',
    PRMTMSG_MODIFY_SUCCEED: 'Se actualizó la información del grupo de usuarios.',
    HINT_ADD_USER_GROUP_PLACEHOLDER: 'Escriba un nombre para el grupo de usuarios.',
    HINT_ADD_USER_GROUP_DESCRIPTION_PLACEHOLDER: 'Escriba la descripción del grupo de usuarios.',
    MSG_USER_GROUP_NAME_NEEDED: 'El nombre del grupo de usuarios es obligatorio.',
    MSG_USER_GROUP_DESCRIPTION_NEEDED: 'La descripción del grupo de usuarios es obligatoria.',

    BTN_VIEW: 'Vista',
    COLH_ASSIGNED_USER: 'Usuarios asignados',
    COLH_CREATE_BY: 'Creado por',
    COLH_CREATE_TIME: 'Creado el'
  },
  MENU: {
    BTN_APP_MGR: 'Administración de aplicaciones',
    BTN_USER_PERMISSION: 'Usuario y permisos',
    BTN_USER_MGR: 'Usuario',
    BTN_ROLE_MGR: 'Rol',
    BTN_USER_GROUP_MGR: 'Grupo de usuarios',
    BTN_STRUCTURE_MGR: 'Estructura organizativa',
    BTN_SUB_ADMIN_MGR: 'Subadministrador',
    BTN_ASSET_PERMISSION_MGR: 'Permiso del activo',
    BTN_OTHER_MGR: 'Otras configuraciones',
    BTN_ASSET_MGR: 'Administración de activos',
    BTN_OU_CONF: 'Configuración de UO',
    BTN_ASSET_SYN: 'Sincronización de activos',
    BTN_ASSET_TREE: 'Árbol de activos',
    BTN_OU_MGR: 'Administrador de UO',
    BTN_PLUGIN_MGR: 'Administración de complementos',
    BTN_OU: 'UO',
    BTN_DOMAIN: 'Configuración del dominio',
    BTN_SECURITY_SETTING: 'Configuración de seguridad',
    BTN_ACCOUNT_PROTECTION: 'Protección de la cuenta',
    BTN_SECURITY_MGR: 'Administración de seguridad',
    BTN_AUDIT_LOG: 'Registro de auditoría'
  },
  MENU_GROUP: {
    BTN_ADD_MENU_GROUP: 'Nuevo grupo de menús',
    DEFAULT_MENU_GROUP: 'Grupo de menús predeterminado',
    TITLE_ADD_MENU_GROUP: 'Nuevo grupo de menús',
    PRMTMSG_ADD_SUCCEED: 'Se creó el nuevo grupo de menús.',
    TITLE_MODIFY_MENU_GROUP: 'Cambiar el nombre del grupo de menús',
    PRMTMSG_MODIFY_SUCCEED: 'Se cambió el nombre del grupo de menús.',
    TITLE_CONFIRM_DELETE: 'Eliminar grupo de menús',
    WINMSG_DELETE_HINT:
      'Las asociaciones con el grupo de menús también se quitarán. ¿Está seguro de que desea eliminar el grupo de menús?',
    PRMTMSG_DELETE_SUCCEED: 'Se eliminó el grupo de menús.',
    TITLE_ASSGIN_MENU_GROUP: 'Administrar menús',
    BTN_ASSGIN_MENU_GROUP: 'Administrar menús',
    TXT_MENU_GROUP: 'Grupo de menús',
    TXT_ASSGIN_MENU: 'Menús asignados'
  },
  APP: {
    COLH_NAME: 'Nombre de la aplicación',
    TITLE_CATEGORY: 'Categoría de la aplicación',
    TITLE_PAGENAME: 'Aplicación',
    COLH_STATUS: 'Habilitar',
    COLH_STRUCTURE: 'Estructura organizativa',
    HINT_ASSIGN_STRUCTURE: 'Asignar estructura organizativa',
    TITLE_ASSIGN_STRUCTURE: 'Asignar estructura organizativa',
    MANAGE_MENU_GROUP: 'Administrar grupos de menús',
    TITLE_ClOSE_APP_STATUS: 'Deshabilitar aplicación',
    TITLE_OPEN_APP_STATUS: 'Habilitar aplicación',
    WINMSG_ClOSE_APP_STATUS_HINT:
      'La aplicación se ocultará del iniciador de aplicaciones para todos los usuarios. ¿Está seguro de que desea deshabilitar la aplicación?',
    WINMSG_OPEN_APP_STATUS_HINT:
      'La aplicación aparecerá en el iniciador de aplicaciones para los usuarios autorizados. ¿Habilitar la aplicación?',
    HINT_CHANGE_STRUCTURE: 'Cambiar estructura organizativa',
    TITLE_APP_MANAGE: 'Aplicación',
    BTN_SORT: 'Ordenar',
    TXT_SORT_WARNING: 'Configure el orden de las aplicaciones en el iniciador de aplicaciones.',
    HINT_CAN_NOT_SORT: 'No se encontraron aplicaciones',
    BTN_CREATE_SHORTCUT_APP: 'Nuevo acceso directo',
    BTN_MGR_SHORTCUT_APP: 'Administrar acceso directo',
    BTN_DELETE_SHORTCUT_APP: 'Eliminar acceso directo',
    TITLE_SHORTCUT: 'Acceso directo',
    TITLE_DELETE_SHORTCUT_MODAL: 'Eliminar acceso directo',
    CONTENT_DELETE_SHORTCUT_MODAL: 'Los accesos directos eliminados no se pueden recuperar. ¿Está seguro de que desea eliminar el acceso directo?',
    MSG_DELETE_SHORTCUT_SUCCESS: 'Se eliminó el acceso directo.',
    TXT_SHORTCUT_DETAIL: 'Detalles del acceso directo',
    TITLE_ADD_SHORTCUT_FAIL: 'Error al crear el acceso directo',
    MSG_ADD_SHORTCUT_SUCCESS: 'Se creó el acceso directo.',
    COLH_MAIN_APP: 'Aplicación principal',
    COLH_APP_NAME: 'Nombre',
    COLH_NAME_ZH: 'Nombre (chino)',
    COLH_NAME_EN: 'Nombre (inglés)',
    COLH_CATEGORY: 'Categoría de la aplicación',
    COLH_DESCRIPTION: 'Descripción',
    TITLE_MODIFY_BASIC_INFO: 'Editar información básica',
    MESSAGE_MODIFY_SUCCEED: 'Se actualizó la información básica.',
    TITLE_ADDED_APP: 'Menús agregados',
    BTN_ADD_MENU: 'Agregar menús',
    TXT_ADD_FROM_OTHER_APP: 'Agregar desde otras aplicaciones',
    TXT_ADD_FIRST_CLASS_MENU: 'Agregar menú de nivel superior',
    TITLE_CHOOSE_APP: 'Paso 1. Seleccione una aplicación',
    TITLE_ASSIGN_MENU: 'Paso 2. Seleccionar menús',
    HINT_ADD_SUB_MENU: 'Agregar submenús',
    HINT_DELETE: 'Eliminar',
    HINT_EDIT: 'Editar',
    HINT_ADD_MENU_ZH_PLACEHOLD: 'Escriba el nombre del menú en chino.',
    HINT_ADD_MENU_EN_PLACEHOLD: 'Escriba el nombre del menú en inglés.',
    TITLE_CONFIRM_DELETE: 'Eliminar menú',
    TXT_CONFIRM_DELETE: 'Los menús eliminados no se pueden restaurar. ¿Está seguro de que desea eliminar el menú?',
    TITLE_CONFIRM_DELETE_AGAIN: 'Eliminar menú de nivel superior y sus submenús',
    HINT_DELETE_MENU_SUCCEED: 'Se eliminó el menú.',
    HINT_CREATE_MENU_SUCCEED: 'Se agregó el menú.',
    HINT_ADD_MENU: 'Puede agregar menús desde otras aplicaciones o agregar un nuevo menú de nivel superior.',
    WINMSG_APP_NO_MENU: 'No hay menús disponibles.',
    TXT_SOURCE: 'Origen',
    BTN_API_AUTHORIZATION: 'Autorización de API',
    MSG_API_AUTHORIZATION: 'Autorización de API',
    TXT_API_AUTHORIZATION: 'Permitir que la aplicación realice las siguientes operaciones a través de las API',
    TXT_API_AUTHORIZATION_USER: 'Obtener el ID, nombre de usuario, correo electrónico y número de teléfono de todos los usuarios de la UO',
    TXT_API_AUTHORIZATION_ASSET: 'Obtener el ID y el nombre de todos los recursos de la UO',
    MSG_API_AUTHORIZATION_SUCCESS: 'Se actualizó la configuración de autorización de API.',
    BTN_VIEW_MENU: 'Ver menús',
    BTN_SORT_MENU: 'Ordenar menús',
    TXT_SORT_MENU_WARNING: 'Modifique el orden de los menús. El nuevo orden surtirá efecto la próxima vez que inicie sesión.',
    HINT_MODIFY_MENU_SUCCESS: 'Se cambió el nombre del menú.',
    HINT_SORT_MENU_SUCCESS: 'Se actualizó el orden de los menús.',
    MESSAGE_ADD_NEEDED: 'Escriba el nombre del menú.',
    MESSAGE_RENAME_NEEDED: 'Escriba el nombre del acceso directo',
    MESSAGE_RENAME_MENU_GROUP_NEEDED: 'Escriba el nombre del grupo de menús',
    HINT_SORT_APP_SUCCESS: 'Las aplicaciones se organizan con el nuevo orden.',
    HINT_ASSIGN_APP_STRUCTURE: 'Se asignó la estructura organizativa.',
    MSG_ADD_MENU_SUCCESS: 'Se agregaron los menús.',
    MSG_SHORTCUT_NAME_NEEDED: 'El nombre del acceso directo es obligatorio.',
    COLH_NAME_JA: 'Nombre (japonés)',
    COLH_NAME_ES: 'Nombre (español)',
    LABEL_URL: 'URL',
    TXT_API_AUTHORIZATION_ROLE: 'Obtener el ID y el nombre de todos los roles de la UO',
    WINMSG_APP_NO_PERMISSION: 'No hay permisos disponibles',
    TITLE_DELETE_PERMISSION: 'Eliminar permiso',
    WINMSG_PERMISSION_DELETE_CHECK:
      'El acceso directo de aplicación perderá acceso a las operaciones asociadas con el permiso. ¿Está seguro de que desea eliminar el permiso?',
    TITLE_ADDED_PER: 'Permisos agregados',
    BTN_ASSIGNMENT_PURVIEW_POINT: 'Agregar permisos',
    HINT_ADD_PER: 'Puede agregar permisos de otras aplicaciones. Después de agregar los permisos, puede asignarlos a roles a fin de permitir que los usuarios accedan a las operaciones asociadas.',
    PRMTMSG_ASSPERMISSION_SUCCESS: 'Permisos agregados correctamente',
    PRMTMSG_REMPERMISSION_SUCCESS: 'Permiso eliminado',
    TITLE_DOWNLOAD_NAME: 'ListaUsuarios',
    TXT_STRUCTURE_SELECT: 'Seleccione hasta {0} estructuras organizativas',
    TITLE_UNBIND: 'Eliminar estructura organizativa asignada',
    WINMSG_UNBIND: 'La estructura organizativa está asignada a roles. Los roles ya no podrán ver esta estructura organizativa una vez que la elimine. Proceda con cuidado.',
    NO_STRUCTURE: 'No hay una estructura organizativa disponible. Primero cree una',
    BTN_ALL_APP: 'Todas las aplicaciones',
    BTN_PURCHASED_APP: 'Aplicaciones compradas',
    BTN_SELFDESIGNED_APP: 'Aplicaciones personalizadas',
    COLH_NEWNAVIGATION: 'Estilo de navegación nuevo',
    TXT_NEWNAVIGATION: 'Si deshabilita el estilo de navegación nuevo, las aplicaciones mantendrán el estilo actual',
    TITLE_OLDNAVIGATION: 'Estilo de navegación anterior',
    TXT_SHOW_MENU_NAME: 'Mostrar etiquetas',
    TXT_SHOW_ICON: 'Mostrar iconos',
    TXT_FOLDER_SUBMENU: 'Ampliar/contraer submenús',
    TXT_ICON_MENU: 'Solo mostrar íconos',
    TITLE_CLOSE_NEWNAVIGATION: '¿Deshabilitar la navegación nueva?',
    TXT_CLOSE_NEWNAVIGATION: 'Si deshabilita la navegación nueva, se cambiará al estilo anterior sin íconos.',
    BTN_APP_MENUMANAGEMENT: 'Administración de menús',
    TXT_MENU_MANAGEMENT: 'Administración de menús'
  },
  MENU_MANAGEMENT: {
    TXT_SEARCH: 'Buscar por nombre o identificador de menú',
    COLH_MENU_ICON_NAME: 'Ícono/etiqueta',
    COLH_MENU_CODE: 'Identificador',
    COLH_ORDER: 'Ordenar',
    COLH_URL: 'URL',
    TITLE_ADDITION: 'Detalles',
    TITLE_SWITCH: 'Cambiar a',
    TITLE_OPEN: 'Ampliar',
    TXT_SWITCHMENU: 'Abrir este submenú',
    TITLE_MENU_NAME: 'Nombre',
    TITLE_MENU_PROPERTY: 'Propiedad',
    TITLE_OPEN_SUBMENU: 'Ampliar submenú',
    TITLE_SWITCH_SUBMENU: 'Abrir submenú',
    TITLE_SELECT_ICON: 'Seleccionar un ícono',
    BTN_SAVE: 'Guardar',
    MSG_ICON_SAVE_SUCCESSFULLY: 'Ícono guardado.'
  },
  STRUCTURE: {
    TITLE_STRUCTURE_MANAGE: 'Estructura organizativa',
    TITLE_MANAGE_STRUCTURE: 'Estructura organizativa',
    BTN_ADD_STRUCTURE: 'Nueva estructura organizativa',
    COLH_NAME: 'Nombre de la estructura organizativa',
    WINMSG_DELETE_STRUCTURE_HINT:
      'Las estructuras organizativas eliminadas no se pueden recuperar. ¿Está seguro de que desea eliminar la estructura organizativa?',
    TITLE_ADD_STRUCTURE: 'Nueva estructura organizativa',
    PRMTMSG_ADD_SUCCEED: 'Se creó la estructura organizativa.',
    PRMTMSG_ADD_CHILD_SUCCEED: 'Se agregó el nodo.',
    DELETE_STRUCTURE_SUCCEED: 'Se eliminó la estructura organizativa.',
    INLINE_STRUCTURE_AMOUNT: 'Se pueden crear cinco estructuras organizativas como máximo.',
    COLH_AUTO_ASSGIN_STATUS: 'Autorización automática de activos',
    TITLE_ClOSE_STRUCTURE_AUTO_DISPATCH: 'Deshabilitar autorización automática de activos',
    TITLE_OPEN_STRUCTURE_AUTO_DISPATCH: 'Habilitar autorización automática de activos',
    WINMSG_ClOSE_STRUCTURE_AUTO_DISPATCH:
      'Los usuarios perderán el acceso a todos los activos secundarios de los nodos en los que están asignados. ¿Está seguro de que desea deshabilitar la autorización automática de activos?',
    WINMSG_OPEN_STRUCTURE_AUTO_DISPATCH:
      'Los usuarios obtendrán acceso automático a todos los activos secundarios de los nodos en los que están asignados. ¿Habilitar autorización automática de activos?',
    BTN_ADD_SUB_NODE: 'Agregar nodo secundario',
    BTN_MANAGE_ASSET: 'Administrar activos',
    BTN_MANAGE_USER: 'Ver usuario',
    TITLE_ADD_NODE: 'Agregar nodo secundario',
    LABEL_NODE_NAME_ZH: 'Nombre del nodo (zh-CN)',
    LABEL_NODE_NAME_EN: 'Nombre del nodo (en-US)',
    TITLE_CONFIRM_DELETE_STRUCTURE: 'Eliminar estructura organizativa',
    TITLE_CONFIRM_DELETE: 'Eliminar nodo',
    WINMSG_DELETE_HINT: 'Los nodos eliminados no se pueden recuperar. ¿Está seguro de que desea eliminar el nodo?',
    TITLE_MODIFY_STRUCTURE: 'Cambiar nombre',
    PRMTMSG_ASSIGN_SUCCEED:
      'Se actualizó la asignación del activo. Por razones de seguridad, los usuarios pueden acceder a los activos después de tres minutos.',
    TITLE_MANAGE_USER: 'Ver usuario',
    BTN_SYNC_ASSETS: 'Sincronizar activos',
    PRMTMSG_SYNC_SUCCEED: 'Activos sincronizados',
    BTN_SYNCING: 'Sincronizando...',
    HINT_SYNC_ASSETS_HINT: 'Haga clic en "Sincronizar activos" para sincronizar los activos de la OU.',
    PRMTMSG_MODIFY_SUCCEED: 'Se actualizó el nodo.',
    UNASSIGNED_ASSET: 'Activos sin asignar',
    ASSIGNED_ASSET: 'Activos asignados',
    HINT_ADD_STRUCTURE_PLACEHOLDER: 'Escriba el nombre de la estructura organizativa.',
    INLINE_NANME_NEEDED: 'El nombre del nodo es obligatorio.',
    MSG_STRUCTURE_NAME_NEEDED: 'El nombre de la estructura organizativa es obligatorio.',
    MSG_STRUCTURE_NAME_PATTERN: 'La barra vertical "|" y la coma "," "，" no se permiten',
    INLINE_STRUCTURE_HINT:
      'Una estructura organizativa es una jerarquía de administración de activos que utiliza nodos como unidades de administración. Puede configurar la estructura organizativa para permitir que los usuarios accedan automáticamente a todos los activos secundarios de los nodos en los que están asignados.',
    BTN_USER: 'Usuario',
    BTN_ASSET: 'Activo',
    LABEL_NAME: 'Nombre',
    BTN_ADD_TAG: 'Agregar etiqueta',
    BTN_EDIT_TAG: 'Editar etiqueta',
    LABEL_TAG_ID: 'Clave de etiqueta',
    MSG_TAG_ID_INPUT: 'Use solo letras, números, guiones bajos (_), guiones (-) y barras diagonales (/).',
    LABEL_TAG_VALUE: 'Valor de etiqueta',
    HINT_INPUT_TAG_VALUE: 'Introduzca un valor de etiqueta.',
    HINT_INPUT_TAG_ID: 'Introduzca una clave de etiqueta.',
    TAB_TAG: 'Etiqueta',
    TITEL_DELETE_TAG: '¿Eliminar etiqueta?',
    TXT_DELETE_TAG_HINT: 'Las etiquetas eliminadas no se pueden recuperar. ¿Está seguro de que desea eliminar la etiqueta?',
    PRMTMSG_CREATE_TAG_SUCCEED: 'Etiqueta agregada',
    PRMTMSG_MODIFY_TAG_SUCCEED: 'Etiqueta editada',
    MSG_TAG_KEY_EXIST: 'Esta clave de etiqueta ya existe.',
    MSG_DELETE_STRUCTURE_TAG_SUCCEED: 'Etiqueta eliminada',
    BTN_SORT: 'Orden de clasificación',
    MSG_SORT_SUCCESS: 'Guardado',
    MSG_SORT_FAILED: 'Error al guardar.',
    MSG_ASSETSORT_FAILED: 'La operación falló. Inténtelo de nuevo.',
    TXT_SORT_WARNING: 'Sólo puede reordenar nodos dentro del mismo nodo padre. En otras palabras, no puede mover un nodo a un nodo padre diferente.'
  },
  USER: {
    BTN_SEARCH: 'Buscar',
    TITLE_PAGE_NAME: 'Usuario',
    TITLE_USER_DETAIL: 'Detalles de usuario',
    TITLE_USER_ROLE: 'Roles asignados',
    TITLE_USER_STRUCTURE: 'Estructura organizativa asignada',
    TITLE_USER_USER_GROUP: 'Grupos de usuarios asignados',
    TITLE_MODIFY_USER: 'Editar información de usuario',
    BTN_CREATE_USER: 'Agregar usuario',
    TITLE_CREATE_USER_FAILED: 'Error al agregar el usuario',
    MSG_CREATE_USER_FAILED: 'El usuario ya existe y no puede volver a agregarse',
    BTN_ASSIGN_ROLE: 'Asignar rol',
    TITLE_ASSIGN_ROLE: 'Asignar rol',
    BTN_ASSIGN_STRUCTURE: 'Asignar estructura organizativa',
    TITLE_ASSIGN_STRUCTURE: 'Asignar estructura organizativa',
    BTN_ASSIGN_USER_GROUP: 'Asignar grupo de usuarios',
    TITLE_ASSIGN_USER_GROUP: 'Asignar grupo de usuarios',
    TXT_SEARCH: 'Buscar por nombre de usuario o nombre completo',
    BTN_MANAGE: 'Administrar',
    BTN_REMOVE_FROM_OU: 'Quitar de la empresa/organización',
    TITLE_REMOVE_FROM_OU: 'Quitar usuario',
    MSG_REMOVE_FROM_USER_GROUP: 'Quitar del grupo de usuarios',
    MSG_REMOVE_FROM_OU:
      'Cuando se quita a un usuario, este dejará de tener acceso a los activos de la empresa u organización. ¿Está seguro de que desea quitar el usuario?',
    MSG_ASSIGN_ROLE: 'Una vez asignado a un rol, el usuario tendrá los permisos del rol para los menús y el permiso de operaciones.',
    MSG_ASSIGN_USER_GROUP: 'Una vez agregado a un grupo de usuarios, al usuario se le asignará el permiso correspondiente para ver los activos.',
    MSG_ASSIGN_STRUCTURE:
      'Una vez agregado a una organización, al usuario se le asignará el permiso correspondiente para ver los activos de la estructura organizativa.',
    MSG_REMOVE_SUCCESS: 'El usuario se quitó de la empresa/organización.',
    COLH_ACCT_NO: 'Usuario',
    COLH_EMAIL: 'Correo electrónico',
    COLH_NICKNAME: 'Nombre completo',
    COLH_PHONE: 'Teléfono',
    MSG_REMOVE_SELF: 'No puede quitar su propia cuenta de usuario.',
    TITLE_CONFIRM_ADD: 'Agregar usuario',
    MSG_CONFIRM_ADD_USER: '¿Agregar el usuario {0} a la empresa/organización actual?',
    TITLE_MAIL_TO: 'Enviar correo electrónico de invitación a:',
    MSG_ENTER_CORRECT_FORMAT: 'Escriba una dirección de correo electrónico válida.',
    MSG_EMAIL_NO_RESULT: 'No hay resultados coincidentes. ',
    TITLE_CREATE_JOIN: 'Crear una cuenta de usuario',
    MSG_CREATE_EMAIL_SUCCESS: 'Se creó la cuenta de usuario y se envió un correo electrónico de invitación al usuario.',
    MSG_CREATE_EMAIL_NO_EMAIL_SUCCESS: 'Se creó y agregó la cuenta de usuario.',
    MSG_ACCOUNT_EXIST: 'El nombre de usuario ya existe.',
    MSG_ACCOUNT_REQUIRED: 'El nombre de usuario es obligatorio.',
    TXT_ENTER_EMAIL: 'Escriba su dirección de correo electrónico.',
    TXT_ENTER_USER_EMAIL: 'Escriba la dirección de correo electrónico del usuario',
    MSG_CIPHER_NOT_SAME: 'Las contraseñas introducidas no coinciden.',
    MSG_ENTER_CIPHER: 'Escriba la contraseña.',
    MSG_ENTER_EMAIL_AGAIN: 'Vuelva a escribir su dirección de correo electrónico.',
    MSG_ENTER_CIPHER_AGAIN: 'Vuelva a escribir la contraseña.',
    LABEL_CIPHER: 'Establecer contraseña',
    LABEL_CONFIRM_CIPHER: 'Confirmar contraseña',
    TITLE_RESET_CIPHER: 'Restablecer contraseña',
    BTN_RESET_CIPHER: 'Restablecer contraseña',
    TXT_CONFIRM_RESET_CIPHER: 'Restablecer contraseña',
    MSG_CONFIRM_RESET_CIPHER: 'Se enviará al usuario un correo electrónico para restablecer la contraseña. ¿Está seguro de que desea restablecer la contraseña?',
    MSG_TRIGGER_RESET_CIPHER: 'Se envió al usuario un correo electrónico para restablecer la contraseña.',
    MSG_RESET_CIPHER_SUCCESS: 'Volviendo a la página de inicio de sesión...',
    BTN_REDIRECT_IM: 'Volver ahora',
    MSG_SEND_RESET_EMAIL_SUCCESSFULLY: '{0}, que caducará en 24 horas.',
    MSG_JUMP_TO_MAIL_BOX: 'Busque el correo electrónico y restablezca la contraseña de inmediato.',
    BTN_CHANGE_CIPHER_SUCCESSFULLY: 'Se actualizó la contraseña.',
    HOVER_USER_ROLE:
      'Un rol es una colección de permisos funcionales, como permisos de acceso al menú y permisos de operaciones. Una vez que se asigna un rol a un usuario, el usuario tendrá acceso a los menús y las operaciones correspondientes.',
    HOVER_USER_PERMISSION:
      'Una vez que se asignan usuarios a los nodos en una estructura organizativa y se habilita la autorización automática a los activos, los usuarios obtendrán acceso automático a los activos secundarios.',
    HOVER_USER_STRUCTURE:
      'Una vez que se asignan varios usuarios a un grupo de usuarios y se conceden permisos para los recursos al grupo, los usuarios del mismo grupo de usuarios tendrán los mismos permisos para los activos. ',
    TITLE_CONFIRM_REMOVE_ROLE: 'Quitar rol',
    TITLE_CONFIRM_REMOVE_STRUCTURE: 'Quitar estructura organizativa',
    TITLE_CONFIRM_REMOVE_USER_GROUP: 'Quitar grupo de usuarios',
    WINMSG_DELETE_CHECK: 'El usuario perderá los permisos asociados. ¿Está seguro de que desea quitarlo?',
    WINMSG_DELETE_ROLE_CHECK: 'El usuario perderá los permisos asociados con el rol. ¿Está seguro de que desea quitar el rol?',
    WINMSG_DELETE_STRUCTURE_CHECK:
      'El usuario perderá los permisos asociados con la estructura organizativa. ¿Está seguro de que desea quitar el usuario de la estructura organizativa?',
    WINMSG_SUB_DELETE_STRUCTURE_CHECK:
      'El usuario perderá los permisos asociados con la estructura organizativa. Además, no podrá seguir administrando al usuario. ¿Está seguro de que desea quitar el usuario de la estructura organizativa?',
    WINMSG_DELETE_USERGROUP_CHECK:
      'El usuario perderá los permisos asociados con el grupo de usuarios. ¿Está seguro de que desea quitar el usuario del grupo de usuarios?',
    PRMTMSG_REMOVE_SUCCEED: 'Se quitó el rol del usuario.',
    STRUCTURE_REMOVE_SUCCEED: 'El usuario se quitó de la estructura organizativa.',
    USER_GROUP_REMOVE_SUCCEED: 'El usuario se quitó del grupo de usuarios.',
    PRMTMSG_MODIFY_USER_SUCCEED: 'Actualizado correctamente',
    COLH_DESCRIPTION: 'Descripción',
    COLH_USER_ROLE: 'Rol',
    COLH_USER_STRUCTURE: 'Estructura organizativa',
    COLH_USER_USER_GROUP: 'Grupo de usuarios',
    MSG_ACCOUNT_NUMBER_REQUIRED: 'Escriba un número.',
    TXT_SELECTED_STRUCTURE: 'Estructura organizativa seleccionada',
    MSG_EMAIL_NOT_SAME: 'Las direcciones de correo electrónico introducidas no coinciden.',
    LABEL_NEW_CIPHER: 'Nueva contraseña',
    LABEL_OLD_CIPHER: 'Contraseña anterior',
    LABEL_CONFIRM_NEW_CIPHER: 'Confirmar nueva contraseña',
    MSG_NO_CIPHER: 'La contraseña es obligatoria.',
    MSG_ENTER_OLD_CIPHER: 'Escriba la contraseña anterior.',
    MSG_ENTER_NEW_CIPHER: 'Escriba la contraseña nueva.',
    MSG_NEW_CIPHER_NOT_SIMILAR: 'Las contraseñas introducidas no coinciden.',
    MSG_NEW_OLD_CIPHER_SIMILAR: 'La nueva contraseña no puede ser la misma que la contraseña anterior.',
    MSG_MODIFY_CIPHER_SUCCESS: 'Se cambió la contraseña.',
    MSG_ACCOUNT_CANNOT_CHANGE: 'No es posible cambiar el tipo de cuenta y el dominio.',
    MSG_CREATE_ADD_USER: 'Nueva cuenta de usuario',
    MSG_INVALIDATE_CIPHER: 'La contraseña no cumple con los requisitos.',
    MSG_CIPHER_PATTERN:
      'La contraseña debe tener al menos 8 caracteres e incluir al menos una letra mayúscula, una letra minúscula y un número. También puede contener los caracteres especiales !@#%&$*()[]{}|.',
    HINT_USER_REQUIRED: 'El nombre de usuario es obligatorio.',
    HINT_REGION_REQUIRED: 'El alcance de administración es obligatorio.',
    MSG_SUB_ADMIN_ADD_EXIST_USER: 'El usuario ya existe y no puede volver a agregarse.',
    TITLE_USER_BATCH_IMPORT: 'Importación por lotes',
    BTN_BATCH_IMPORT: 'Importación por lotes',
    MSG_DOWNLOAD_IMPORT_TEMPLATE: 'Descargar plantilla',
    MSG_UPLOAD_WRITTEN_FILE: 'Cargar archivo',
    MSG_A_IMPORT_TEMPLATE_DOWNLOAD: 'Descargar plantilla',
    TITLE_UPLOAD_FILE_ERROR: 'Error de carga',
    TITLE_UPLOAD_FILE_FORMAT_ERROR: 'Formato de archivo no válido',
    TITLE_UPLOAD_FILE_SIZE_ERROR: 'Los registros superan el límite ',
    MSG_UPLOAD_FILE_SIZE_ERROR: 'El tamaño del archivo no puede superar los 2 MB.',
    MSG_UPLOAD_FILE_FORMAT_ERROR: ' Cargue solo archivos .xls o .xlsx.',
    BTN_UPLOAD_SELECT: 'Seleccionar archivo',
    BTN_START_UPLOAD: 'Cargar',
    TITLE_BATCH_IMPORT_EXPLANATION: 'La función de importación por lotes le permite agregar varios usuarios, así como asignar roles y estructuras organizativas al mismo tiempo. Descargue la plantilla, complete allí la información necesaria y cargue el archivo.',
    MSG_A_BATCH_IMPORT_EXPLANATION: 'Límite tamaño de archivo: 2 MB. Registros de usuario máx. por archivo: 1000. Formato de archivo: {0}',
    TITLE_RECENT_FAILED_RECORD: 'Última importación',
    MSG_A_DOWNLOAD_FAILED_IMPORT_RECORD: 'Descargar registros con errores',
    BTN_UPLOADING: 'Cargando',
    BTN_PROCESSING: 'Procesando',
    MSG_HISTORY_SUCCESS_RECORDS: 'El {0} importó {1} miembro(s)',
    MSG_HISTORY_FAILED_RECORDS: ', y no se pudieron importar {0} miembro(s).',
    TITLE_TEMPLATE_NAME: 'Plantilla.xlsx',
    TITLE_HISTORY_RECORDS_NAME: '{0}_Registros con errores.xlsx',
    LABEL_USER_TYPE: 'Tipo',
    LABEL_USER_ACCOUNT_AD: 'Cuenta de dominio',
    LABEL_USER_ACCOUNT_INTERNAL: 'Cuenta interna',
    LABEL_USER_SOURCE: 'Dominio',
    MSG_CIPHER_RULES: 'Reglas de contraseña: {0}',
    TITLE_CONFIRM_RESET_CIPHER: 'Restablecer contraseña',
    MSG_CONFIRM_RESTE_CIPHER: 'El sistema generará una nueva contraseña. ¿Está seguro de que desea restablecer la contraseña?',
    TITLE_CONFIRM_RESTE_CIPHER: 'El sistema generará una nueva contraseña automáticamente. ¿Confirmar restablecimiento de contraseña?',
    MSG_NOTICE_CONTENT: 'El sistema no puede enviar una notificación por correo electrónico a este usuario. Envíe al usuario la URL de inicio de sesión, el nombre de usuario y la contraseña en forma manual.',
    BTN_COPY_ACCOUNT_CIPHER: 'Copiar',
    TXT_CORY_SUCCESS: 'Se copiaron el nombre de usuario y la contraseña.',
    TITLE_RESET_CIPHER_SUCCESS: 'Se restableció la contraseña.',
    TITLE_CREATE_ADD_ACCOUNT_SUCCESS: 'Se creó y agregó la cuenta de usuario.',
    HINT_INCORRECT_PHONE_NUMBER: 'Introduzca un número de teléfono con formato válido.',
    PLACEHOLD_SELECT_USER: 'Seleccionar',

    COLH_ACCOUNT_START_TIME: 'Válida desde',
    HINT_ACCOUNT_START_TIME: 'La fecha en que se activa la cuenta y el usuario puede comenzar a iniciar sesión en la OU.',
    COLH_ACCOUNT_EXPIRE_TIME: 'Válida hasta',
    HINT_ACCOUNT_EXPIRE_TIME: 'El último día de validez de la cuenta. El usuario ya no puede iniciar sesión en la OU después de esta fecha.',
    BTN_BATCH_EXPORT: 'Exportación en masa',
    TITLE_BATCH_EXPORT: 'Exportación en masa',
    COLH_CREATE_TIME: 'Creado el',
    TITLE_COMPANY: 'Empresa',
    TITLE_DEPARTMENT: 'Departamento',
    TITLE_POSITION: 'Puesto'
  },
  SUB_ADMIN: {
    COLH_NAME: 'Usuario',
    COLH_MANAGEMENT_REGION: 'Alcance de administración',
    COLH_AVAILABLE_ROLE: 'Roles administrados',
    BTN_MANAGE: 'Administrar',
    BTN_REMOVE_FROM_OU: 'Quitar',
    TITLE_REMOVE_SUB_ADMIN: 'Quitar subadministrador',
    TEXT_REMOVE_SUB_ADMIN: 'El usuario perderá los derechos de administración. ¿Está seguro de que desea quitar el subadministrador?',
    TITLE_REMOVE_FAIL: 'Error al quitar el subadministrador.',
    MSG_REMOVE_SUCCESS: 'Se quitó el subadministrador.',
    BTN_CREATE_SUB_ADMIN: 'Agregar subadministrador',
    TEXT_COMMA: ',',
    TITLE_PAGE_NAME: 'Subadministrador',
    TITLE_NEW_SUB_ADMIN: 'Agregar subadministrador',
    TITLE_MANAGE_SUB_ADMIN: 'Detalles del subadministrador',
    INLINE_SUB_ADMIN_DETAIL_HINT:
      'Los subadministradores pueden administrar permisos de usuario, como asignar roles o permisos de activos, a una estructura organizativa específica.',
    TITLE_SELECT_USER: 'Seleccionar usuario',
    TITLE_SET_REGION: 'Seleccionar alcance de administración',
    TITLE_SELECT_ROLE: 'Seleccionar roles administrados',
    TEXT_REGION_HINT:
      'Seleccione las estructuras organizativas que puede administrar el subadministrador.',
    TEXT_ROLE_HINT: 'Seleccione los roles que el subadministrador puede asignar a los usuarios.',
    BTN_SUBMIT: 'Enviar',
    HINT_SELECT_USER: 'Buscar por nombre de usuario',
    HINT_SET_REGION: 'Seleccionar estructuras organizativas',
    HINT_SELECT_ROLE: 'Seleccionar roles',
    HINT_NO_MATCH_DATA: 'No hay resultados coincidentes.',
    HINT_USER_REQUIRED: 'El nombre de usuario es obligatorio.',
    HINT_REGION_REQUIRED: 'El alcance de administración es obligatorio.',
    MSG_CREATE_SUCCESS: 'Se agregó el subadministrador.',
    MSG_UPDATE_SUCCESS: 'Se actualizó la información del subadministrador.',
    BTN_VIEW: 'Vista',
    COLH_MANAGEMENT_AUTHORITY: 'Derechos administrativos',
    COLH_ALLOCATION: 'Método de asignación',
    COLH_ASSIGNED_MANAGEMENT_REGION: 'Alcance de administración',
    TXT_SUBADMIN_NAME: 'Subadministrador',
    TITLE_SELECT_SUB_ADMIN: 'Subadministrador',
    HINT_SELECT_ALLOCATION: 'Seleccionar método de asignación',
    HINT_SELECT_REGION: 'Seleccionar alcance de administración',
    TITLE_SELECT_FUNCTION: 'Capacidades disponibles',
    TXT_APPLICATION: 'Administrar aplicaciones', // 目前后端提供
    TXT_USER: 'Gestión de usuarios', // 目前后端提供
    TXT_ROLE: 'Administrar roles', // 目前后端提供
    TXT_USER_GROUP: 'Administrar grupos de usuarios', // 目前后端提供
    TXT_ASSET_PERMISSION: 'Asignar permisos de activos', // 目前后端提供
    TXT_AUDIT_LOG: 'Administrar registros de auditoría', // 目前后端提供
    TXT_ASSIGNED_BY_ORGANIZATION_STRUCTURE: 'Asignar por estructuras organizativas',
    TXT_ASSIGNED_BY_USER_GROUP: 'Asignar por grupos de usuarios',
    TXT_ASSIGNED_BY_ROLE: 'Asignar por roles',
    BTN_ADD: 'Agregar método de asignación',
    TXT_DELETE_CONFIRM: '¿Eliminar método de asignación?',
    MSG_DELETE_CONFIRM: 'El subadministrador perderá los derechos administrativos para el alcance seleccionado.',
    HINT_APPLICATION: 'Los subadministradores pueden administrar los grupos de menús de las aplicaciones.',
    HINT_USER: 'Los subadministradores pueden crear, editar, eliminar, importar en masa y exportar en masa las cuentas de usuarios. También pueden asignar roles, grupos de usuarios y una estructura organizativa a los usuarios.',
    HINT_ROLE: 'Los subadministradores pueden administrar los roles que se les asignan o que ellos crean.',
    HINT_USER_GROUP: 'Los subadministradores pueden administrar los grupos de usuarios que se les asignan o que ellos crean.',
    HINT_ASSET_PERMISSION: 'Los subadministradores pueden asignar permisos de activos a los usuarios o grupos de usuarios.',
    HINT_AUDIT_LOG: 'Los subadministradores pueden ver y exportar sus propios eventos administrativos, y los eventos de inicio y cierre de sesión de los usuarios que administran.',
    HINT_ALLOCATIONS: 'Asignar grupos de usuarios, roles y activos que el subadministrador pueda administrar',
    HINT_OPERATIONS: 'Seleccionar las capacidades del subadministrador',
    TXT_STRUCTURES: 'Estructura organizativa',
    TXT_ROLES: 'Rol',
    TXT_USER_GROUPS: 'Grupo de usuarios'
  },
  ASSET_PERMISSION: {
    TXT_USER: 'Usuario',
    TXT_USER_GROUP: 'Grupo de usuarios',
    HINT_SEARCH: 'Buscar por nombre de usuario',
    HINT_USER_SEARCH: 'Buscar por nombre de usuario o correo electrónico',
    HINT_USER_GROUP_SEARCH: 'Buscar por nombre de grupo de usuarios',
    BTN_MANAGE_ASSET: 'Administrar activos',
    COLH_NAME: 'Activos asignados',
    TITLE_MANAGE_ASSET: 'Administrar activos',
    TXT_ASSGIN_TO: 'Asignar a',
    TITLE_CONFIRM_REMOVE: 'Quitar activo',
    ASSET_PERMISSION_USER: 'El usuario perderá el acceso al activo. ¿Está seguro de que desea quitar el activo?',
    ASSET_PERMISSION_USER_GROUP: 'El grupo de usuarios perderá el acceso al activo. ¿Está seguro de que desea quitar el activo?',
    UNASSIGNED_ASSET: 'Activos sin asignar',
    ASSIGNED_ASSET: 'Activos asignados',
    INLINE_ASSET_PERMISSION_DETAIL_HINT:
      'Asigne activos a los usuarios o grupos de usuarios, de modo que puedan ver los datos del activo correspondiente en las aplicaciones.'
  },
  ASSET_TREE: {
    BTN_MANAGE: 'Administrar',
    TITLE_PAGENAME: 'Administrar estructura organizativa',
    TITLE_ASSET_SYNC:
      'La sincronización de activos es el proceso de sincronizar activos conectados y etiquetados de la Consola de EnOS. Solo es posible asignar permisos de activos a los usuarios una vez que se completa la sincronización.',
    COLH_ASSET_NAME: 'Nombre del activo',
    COLH_SYNC_TIME: 'Sincronizado el',
    MSG_SYNC_ASSET_TREE_FAIL: 'Inténtelo de nuevo más tarde.',
    MSG_SYNC_ASSET_TREE_SUCCESS: 'Sincronización finalizada',
    BTN_SYNC_ING: 'Sincronizando',
    MSG_PROMPT_ASSETS_ALLOCATION: 'Por razones de seguridad, una vez que se asignan los activos, los usuarios pueden acceder a ellos después de tres minutos.'
  },
  OU: {
    TITLE_INFO: 'Información básica',
    TITLE_ADMIN: 'Administrador de UO',
    TITLE_PERSONALITY: 'Personalización',
    TITLE_OU_NAME: 'Nombre de UO',
    TITLE_OU_ADDRESS: 'Dirección',
    TITLE_INDUSTRY: 'Industria',
    TITLE_LOGO: 'Logotipo',
    TITLE_ADMIN_ACCOUNT: 'Cuenta de administrador',
    TITLE_ADMIN_NAME: 'Nombre del administrador',
    BTN_CHANGE_MANAGER: 'Cambiar administrador',
    TITLE_CHANGE_MANAGER: 'Cambiar administrador',
    LABEL_CURRENT_ADMIN: 'Administrador actual',
    LABEL_NEW_ADMIN: 'Nuevo administrador',
    TITLE_CHANGE_ADMIN: 'Cambiar administrador',
    WINMSG_CHANGEADMIN_HINT1: '{0} se establecerá como el nuevo administrador.',
    WINMSG_CHANGEADMIN_HINT2: 'Dejará de ser el administrador.',
    WINMSG_CHANGEADMIN_HINT3: '¿Está seguro de que desea cambiar el administrador?',
    HINT_NO_MATCH_DATA: 'No se encontraron datos coincidentes',
    HINT_INPUT_HINT: 'Buscar por nombre de usuario o correo electrónico',
    INLINE_NEEDED: 'El nuevo administrador es obligatorio.',
    BTN_REUPLOAD: 'Cargar imagen',
    MSG_FILE_UPLOAD_SUCCEED: 'Imagen cargada',
    TXT_CHANGE_LOGO_HINT: 'El logotipo aparecerá en la parte superior de la barra de navegación. Se recomienda que utilice una imagen con las siguientes especificaciones: 200 x 32 píxeles, fondo transparente, formato PNG o SVG.',
    TXT_SEARCH: 'Buscar por nombre de UO',
    TITLE_LANGUAGE_SETTING: 'Configuración de idioma',
    TITLE_LANGUAGE: 'Idiomas disponibles',
    TXT_EDIT: 'Editar',
    TITLE_LAN_SETTING: 'Configuración de idioma',
    HINT_EDIT_LAN_HINT: 'Seleccione los idiomas disponibles para todos los usuarios de la empresa o la organización.',
    HINT_LANG_SETTING_SUCCEED: 'Se actualizó la configuración de idioma.',
    TITLE_PAGEFOOTER: 'Pie de página',
    TITLE_EDITPAGEFOOTER: 'Editar pie de página',
    MSG_NULLFOOTER: 'El pie de página está en blanco',
    TXT_NULL: '(En blanco)',
    MSG_EDITPAGEFOOTER_SUCCESS: 'El pie de página se guardó',
    HINT_NOTBUY: 'La OU actual no compró esta función'
  },
  PORTAL: {
    BTN_ADMIN_CONSOLE: 'Consola de administración',
    TITLE_IFRAME_ERROR: 'Error de iframe.',
    MSG_INVALIDATE_URL: 'URL de menú no válida',
    MSG_LOADING_FRAME: 'Cargando...',
    NO_APP: 'No hay aplicaciones disponibles.',
    BTN_CHANGE_APP: 'Cambiar aplicación'
  },
  SUPER: {
    TITLE_ASSIGN_OU_ADMIN: 'Asignar administrador',
    TITLE_RESET_ADMIN_CIPHER: 'Restablecer contraseña de administrador',
    TITLE_CONFIRM_RESET_CIPHER: '¿Está seguro de que desea restablecer la contraseña de administrador?',
    MSG_CONFIRM_RESET_CIPHER: 'Se enviará un correo electrónico para restablecer la contraseña de administrador a:',
    MSG_CREATE_USER_AS_ADMIN: 'Crear una cuenta de administrador',
    MSG_CONFIRM_SET_ADMIN: '¿Asignar al usuario como administrador?',
    TXT_CONFIRM_SET_ADMIN: 'Se asignará a {0} como administrador y se enviará un correo electrónico de invitación a {1}. ¿Enviar el correo electrónico?',
    TXT_EDGE_CONFIRM_SET_ADMIN: '¿Asignar a {0} como administrador?',
    TITLE_OU_NAME: 'Nombre de OU',
    TITLE_CURRENT_OU: 'Administrador actual',
    TITLE_NOT_ASSIGN: '(Administrador no asignado)',
    MSG_CONFIRM_CHANGE_ADMIN: '¿Confirma que desea cambiar el administrador?',
    TXT_CONFIRM_CHANGE_ADMIN1: 'El administrador cambiará de {0} a {1}.',
    TXT_CONFIRM_CHANGE_ADMIN2: 'Se enviará un correo electrónico de invitación a {0}. ¿Confirma que desea enviar el correo electrónico?',
    MSG_SEND_EMAIL_SUCCESSFULLY: 'Correo electrónico enviado'
  },
  PLUGIN: {
    BTN_REGISTER_PLUGIN: 'Registrar complemento',
    TITLE_PLUGIN_NAME: 'Nombre',
    TITLE_NAME_DEFAULT: 'Nombre',
    TITLE_NAME_ENGLISH: 'Nombre (inglés)',
    TITLE_URL: 'URL',
    TITLE_DESCRIPTION: 'Descripción',
    BTN_ASSIGN_OU: 'Asignar UO',
    HINT_ADD_PLUGIN_NAME_PLACEHOLDER: 'Escriba el nombre del complemento.',
    HINT_ADD_PLUGIN_URL_PLACEHOLDER: 'Escriba una URL válida.',
    BTN_CANCELTEXT: 'Cancelar',
    BTN_OKTEXT: 'Enviar',
    TITLE_MODAL_REGISTER_PLUGIN: 'Registrar complemento',
    TITLE_MODAL_MODIFY_PLUGIN: 'Editar complemento',
    TITLE_MODAL_ASSIGN_OU: 'Asignar UO',
    TITLE_MODAL_DELETE_PLUGIN: 'Eliminar complemento',
    CONTENT_MODAL_DELETE_PLUGIN: 'Los complementos eliminados no se pueden recuperar. ¿Está seguro de que desea eliminar el complemento?',
    CONTENT_MODAL_DELETE_PLUGIN_FAILED1: 'El complemento tiene asignados usuarios y no se puede eliminar.',
    CONTENT_MODAL_DELETE_PLUGIN_FAILED2: 'Quite la UO asignada antes de eliminar el complemento.',
    INPUT_NAME_NEEDED: 'El nombre del complemento es obligatorio.',
    INPUT_NAME_CHINESE_NEEDED: 'El nombre del complemento (ZH) es obligatorio.',
    INPUT_NAME_ENGLISH_NEEDED: 'El nombre del complemento (EN) es obligatorio.',
    INPUT_URL_NEEDED: 'La URL del complemento es obligatoria.',
    INPUT_DESCRIPTION_NEEDED: 'La descripción del complemento es obligatoria.',
    MESSAGE_REGISTER_SUCCEED: 'Se registró el complemento.',
    MESSAGE_MODIFY_SUCCEED: 'Se actualizó el complemento.',
    MESSAGE_ASSIGN_OU: 'Se asignó la UO.',
    MESSAGE_DELETE_SUCCESS: 'Se eliminó el complemento.',
    MSG_ASSIGN_OU: 'Una vez asignado el complemento a la UO, el administrador de la UO podrá usarlo.',
    TXT_OU: 'UO',
    TXT_SELECTED_OU: 'UO seleccionada'
  },
  MESSAGE: {
    TITLE_NAME: 'Notificaciones',
    TXT_SHOW_ALL: 'Ver todas',
    TXT_NO_MESSAGE: 'No hay mensajes',
    TXT_TO_SOUND: 'Activar sonido',
    TXT_TO_MUTE: 'Desactivar sonido',
    TXT_DISABLE_DIALOG: 'Deshabilitar ventana emergente',
    TXT_DIALOG: 'Habilitar ventana emergente',
    TXT_CLOSE_DIALOG: 'Cerrar',
    TXT_APP_HINT1: 'Quedan {0} aplicación(es) y {1} alerta(s)',
    TXT_APP_HINT2: 'Contraer',
    TXT_MESSAGE: 'Mensaje',
    TXT_LOAD_MORE: 'Cargar más',
    TXT_LOADING: 'Cargando',
    TXT_LOAD_FAILED: 'Error al cargar. Vuelva a intentarlo.'
  },
  DOMAIN: {
    BTN_ADD_DOMAIN: 'Agregar dominio',
    TXT_DOMAIN_NAME: 'Nombre del dominio',
    TXT_DOMAIN_URL: 'URL',
    TXT_DOMAIN_DESCRIPTION: 'Descripción',
    TITLE_ADD_DOMAIN: 'Agregar dominio',
    MESSAGE_ADD_SUCCEED: 'Se agregó el dominio.',
    TITLE_MODIFY_DOMAIN: 'Editar dominio',
    MESSAGE_MODIFY_SUCCEED: 'Se actualizó la información del dominio.',
    TITLE_MODAL_DELETE_DOMAIN: 'Eliminar dominio',
    CONTENT_MODAL_DELETE_DOMAIN: 'Los dominios eliminados no se pueden recuperar. ¿Está seguro de que desea eliminar el dominio? ',
    MESSAGE_DELETE_SUCCESS: 'Se eliminó el dominio.',
    HINT_ADD_URL_PLACEHOLDER: 'Escriba una URL válida.',
    TXT_ADD_DOMAIN:
      'Agregue los dominios de su empresa u organización para permitir que se agreguen cuentas de usuario del dominio.',
    TXT_DOMAIN_NAME_NEEDED: 'El nombre del dominio es obligatorio.',
    TXT_DOMAIN_URL_NEEDED: 'La URL del dominio es obligatoria.',
    TXT_AUTO_IMPORT: 'Auto-import Users', // TODO
    TXT_YES: 'Yes', // TODO
    TXT_NO: 'No', // TODO
    TXT_ROLES: 'Rol',
    TXT_USER_GROUPS: 'Grupo de usuarios',
    TXT_SELECT_ROLES: 'Select roles', // TODO
    TXT_SELECT_USERGROUPS: 'Select user groups', // TODO
    HINT_NOT_AUTO_IMPORT: 'Manually create EnOS users for SSO in advance', // TODO
    HINT_AUTO_IMPORT: 'Application Portal supports automatically importing SSO users and assigning to roles and user groups. Select "yes" to automatically assign SSO users to selected roles and user groups; Select "No", you need to manually create users in advance in Application Portal.', // TODO
    HINT_AUTO_IMPORT_NECESSARY: 'You need to specify whether to auto-import users', // TODO
    TITLE_DOUBLE_CHECK: 'Are you sure to disable auto-import users?', // TODO
    TXT_DOUBLE_CHECK: 'After disabling auto-import users, you need to create users for SSO in advance. The existing users will remain in current roles and user groups.' // TODO
  },
  SECURITY: {
    TAB_CIPHER_RULES: 'Reglas de contraseña',
    TAB_LOGIN_SECURITY: 'Seguridad de inicio de sesión',
    MSG_CIPHER_RULES: 'Las siguientes reglas de contraseña se aplican a las cuentas de usuario internas de este entorno.',
    MSG_LOGIN_SECURITY: 'Las siguientes reglas de seguridad de inicio de sesión se aplican a todas las cuentas de usuario de este entorno.',
    LABEL_CIPHER_REQUIRED: 'Caracteres obligatorios',
    TITLE_CIPHER_REQUIRED: 'Seleccione al menos una opción',
    LABEL_CIPHER_LENGTH: 'Longitud de la contraseña',
    LABEL_CIPHER_LENGTH_AFTER: 'caracteres',
    LABEL_CIPHER_LENGTH_BOTTOM: 'Admite entre 8 y 20 caracteres.',
    LABEL_CIPHER_RETRY_CONSTRAINT: 'Límite de reintentos',
    LABEL_CIPHER_RETRY_CONSTRAINT_AFTER: 'veces/hora',
    LABEL_CIPHER_RETRY_CONSTRAINT_BOTTOM: 'La cantidad de veces que se puede escribir una contraseña incorrecta en una hora. La cuenta se bloqueará durante una hora si se supera el límite. Admite entre 1 y 10 reintentos.',
    LABEL_REPEAT_TIMES: 'Límite de reutilización',
    LABEL_REPEAT_TIMES_AFTER: 'veces',
    LABEL_REPEAT_TIMES_BOTTOM: 'La cantidad de contraseñas anteriores que no se pueden reutilizar cuando los usuarios restablecen o cambian la contraseña. Admite entre 1 y 5 contraseñas.',
    LABEL_SINGLE_OR_MORE: 'Varias sesiones iniciadas',
    LABEL_SINGLE_OR_MORE_BOTTOM: 'Cuando se habilita, los usuarios pueden iniciar sesión en una cuenta desde varias ubicaciones a la vez.',
    TITLE_OPEN_MORE_LOGIN: 'Habilitar el inicio de varias sesiones',
    CONTENT_OPEN_MORE_LOGIN: 'Cuando se habilita, los usuarios pueden iniciar sesión en una cuenta desde varias ubicaciones a la vez.',
    TITLE_CLOSE_MORE_LOGIN: 'Deshabilitar el inicio de varias sesiones ',
    CONTENT_CLOSE_MORE_LOGIN: 'Cuando se deshabilita, la sesión actual del usuario se cierra, y se informa que se inició sesión en la misma cuenta desde otra ubicación.',
    LABEL_SESSION_VALID_TIME: 'Tiempo de espera de la sesión',
    LABEL_SESSION_VALID_TIME_AFTER: 'minutos',
    LABEL_SESSION_VALID_TIME_BOTTOM: 'El período de tiempo que un usuario puede estar inactivo antes de que se cierre su sesión. Admite entre 15 y 720 minutos.',
    LABEL_IP_ADDRESS: 'Dirección IP',
    LABLE_IP_ADDRESS_WHITE: 'Lista de permitidos',
    LABEL_IP_ADDRESS_BLACK: 'Lista de no permitidos',
    PLACEHOLD_IP_ADDRESS: 'Separar las direcciones IP por comas',
    LABEL_IP_ADDRESS_BOTTOM_WHITE: 'Lista de permitidos: los usuarios internos solo pueden iniciar sesión desde las direcciones IP que aparecen en la lista.',
    LABEL_IP_ADDRESS_BOTTOM_BLACK: 'Lista de no permitidos: los usuarios internos no pueden iniciar sesión desde las direcciones IP que aparecen en la lista.',
    TITLE_SWITCH_IP_LIST_MODAL: 'Cambiar lista de permitidos/no permitidos',
    CONTENT_SWITCH_IP_LIST_MODAL: 'Las direcciones IP de la lista se perderán después de cambiar la lista. ¿Está seguro de que desea cambiar? ',
    TITLE_ILLEGAL_IP: 'Dirección IP o CIDR no válida.',
    TITLE_LENGTH_BEYOND: 'Puede agregar un máximo de 500 direcciones IP.',
    TXT_LENGTH_HINT: 'Utilice entre {0} y 20 caracteres.',
    TXT_UPPERCASE_HINT: 'Se deben incluir letras mayúsculas.',
    TXT_LOWERCASE_HINT: 'Se deben incluir letras minúsculas.',
    TXT_MUNBER_HINT: 'Se deben incluir números.',
    TXT_SPECIAL_CHARACTER_HINT: 'Se deben incluir caracteres especiales !@#%&*()[]{}-_=|.',
    MESSAGE_SET_CIPHER_RULES_SUCCESS: 'Se actualizaron las reglas de contraseña.',
    MESSAGE_SET_SECURITY_LOGIN_SUCCESS: 'Se actualizó la configuración de seguridad de inicio de sesión.',
    TXT_CIPHER_TYPE_NUMBER: 'Números',
    TXT_CIPHER_TYPE_UPPERCASE: 'Letras mayúsculas',
    TXT_CIPHER_TYPE_LOWERCASE: 'Letras minúsculas',
    TXT_CIPHER_TYPE_CHARACTER: 'Caracteres especiales !@#%&*()[]{}-_=|',
    BTN_SUBMIT_SECURITY: 'Aplicar cambios'
  },
  AUDIT: {
    TXT_AUDIT_LOG: 'El registro de auditoría contiene los eventos de inicio de sesión, cierre de sesión y operaciones del sistema de todos los usuarios de la UO de los últimos {0} días.',
    BTN_EXPORT: 'Exportar',
    BTN_EXPORT_LOADING: 'Exportando',
    TITLE_EVENT_TIME: 'Hora del evento',
    TITLE_ACCOUNT: 'Usuario',
    TITLE_EMAIL: 'Correo electrónico',
    TITLE_ACCOUNT_TYPE: 'Tipo de cuenta',
    TITLE_ASSET_TYPE: 'Tipo de recurso',
    TITLE_EVENT_NAME: 'Evento',
    TITLE_EVENT_DESCRIPTION: 'Descripción',
    TITLE_IP_ADDRESS: 'Dirección IP',
    TITLE_OPERATION: 'Operación',
    TITLE_SEARCH_ACCOUNT: 'Buscar usuarios',
    BTN_SEARCH_ACCOUNT: 'Buscar',
    BTN_RESET_ACCOUNT: 'Restablecer',
    BTN_VIEW_CONTENT: 'Ver detalles',
    TXT_SEMICOLON: '；',
    TITLE_MODAL_DETAIL: 'Detalles del evento',
    TITLE_MODAL_EXPORT: 'Exportar registro',
    TXT_MODAL_EXPORT1: '¿Exportar registros de auditoría para el período de tiempo seleccionado?',
    TXT_MODAL_EXPORT2: 'Si necesita exportar eventos que ocurrieron antes de los últimos {0} días, comuníquese con el administrador del sistema.',
    TITLE_DETAIL_EDIT_BEFORE: 'Antes de editar',
    TITLE_DETAIL_EDIT_AFTER: 'Después de editar',
    TITLE_EXPORT_AUDIT_LOG: 'audit_log_{0}.xlsx',
    TITLE_DOWNLOAD_AUDIT_LOG: 'Descargar el archivo importado'
  },
  OU_SECURITY: {
    TXT_MFA: 'Autenticación multifactor',
    TXT_LOGIN_PROTECTION: 'Protección de inicio de sesión',
    BTN_SUBMIT_SECURITY: 'Aplicar cambios',
    TXT_CLOSE_LOGIN_PROTECTION: 'Deshabilitado',
    TXT_OPEN_EMAIL_AUTH: 'Habilitar autenticación por correo electrónico',
    TXT_EMAIL_AUTH_HINT:
      'Cuando los usuarios inician sesión en el sistema, deben realizar un paso adicional que consiste en escribir un código de verificación que se les envía por correo electrónico.',
    TXT_LOGIN_VALIDATE: 'Autenticación de inicio de sesión',
    LABEL_EMAIL_ADDRESS: 'Correo electrónico',
    LABEL_VERITIFICATION_CODE: 'Código de verificación',
    BTN_SEND_CODE: 'Enviar código de verificación ',
    TXT_INPUT_CODE: 'Escriba el código de verificación.',
    TXT_BACK_TO_LOGIN: 'Volver al inicio de sesión',
    HINT_CODE_SENDED: 'Se envió el código de verificación por correo electrónico.',
    HINT_WRONG_CODE: 'El código de verificación no es válido. Inténtelo de nuevo.',
    HINT_CODE_REQUIRED: 'Escriba el código de verificación.',
    BIN_RESEND_CODE: 'Volver a enviar',
    PRMTMSG_SEND_CODE_SUCCEED: 'Se actualizó la configuración de autenticación multifactor.',

    MSG_CIPHER_RULES: 'Las siguientes reglas de contraseña se aplican a todas las cuentas de usuario internas de esta OU.',
    LABEL_CIPHER_RETRY_CONSTRAINT_BOTTOM: 'La cantidad de ingresos de contraseña incorrectos permitidos en una hora. La cuenta se bloquea durante {0} minutos si se supera este límite. Admite de 1 a 10 reintentos.',
    LABEL_REPEAT_TIMES_BOTTOM: 'La cantidad de contraseñas anteriores que no pueden reutilizarse. Admite entre 1 y 5 contraseñas.',
    LABEL_SESSION_VALID_TIME_AFTER: 'horas',
    LABEL_SESSION_VALID_TIME_BOTTOM: 'El período de tiempo durante el cual un usuario puede permanecer inactivo antes de que se cierre la sesión. Admite de 1 a 240 horas.',
    TXT_SESSION_VALID_TIME: 'Tiempo de espera de la sesión'

  },
  LANDING_PAGE: {
    LABEL_SITE_TIME: 'Site Time',
    HINT_CUSTOMIZE: 'Customzie',
    BTN_ADD_WIDGET: 'Add Widget',
    BTN_SAVE: 'Save',
    BTN_EXIT: 'Exit',
    PLACEHOLD_SEARCH_NAME: 'Search by name',
    TXT_NO_MATCH: 'No matching results',
    BTN_ADD_TO_PAGE: 'Add to Page',
    TITLE_EXIT_CONFIRM: 'Confirm to Exit',
    TXT_UNSAVE_TIP: 'Unsaved configurations will be lost',
    BTN_CANCEL: 'Cancel',
    MSG_FAILED_TO_GET_ASSET: 'Failed to get asset tree',
    TXT_DAY: 'Day',
    TXT_MONTH: 'Month',
    TXT_YEAR: 'Year',
    TXT_MTD: 'MTD',
    TXT_30d: '30d',
    TXT_QTD: 'QTD',
    TXT_3m: '3m',
    TXT_YTD: 'YTD',
    TXT_12m: '12m',
    TXT_Custom: 'Custom',
    LABEL_TIME_INTERVAL: 'Time Interval: ',
    LABEL_SITEM_SELECTED: 'Site: Selected ({0})'
  }
};

export default locale;
